import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'

const options = formFieldCommonOptions('FormRadioGroup', {
    validatorFunction(input) {
        return input
    }
})

export default options
